import { Injectable, Injector } from '@angular/core';
import { Observable, of, throwError } from "rxjs";
import { PathStore } from "../../../store/path.store";
import { HttpClient } from "@angular/common/http";
import { AreaPersonale, PosizioneDebitoria, PosizioneDebitoriaStampaAvviso, PosizioneDebitoria_PagamentiRecenti_Pagata } from "../../../models/payment-area/payment-area.model";
import { StoreService } from "../../store.service";
import { AuthService } from "../../auth/auth.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { CartService } from '../../payment-area/cart.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user.service';
import { UserProfile } from '../../../models/personal-area/user/user-profile';
import { ModalService } from '../../modal.service';

@Injectable({
  providedIn: 'root'
})
export class DebtPositionsService {

  itemIdTodelete: string | undefined
  listaToDeleteFrom!: string
  errorGettingDebtPositionService: boolean = false
  personalAreaDebtPositionsLimit: boolean = false

  constructor(
    private path: PathStore,
    private http: HttpClient,
    private toastr: ToastrService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private storeService: StoreService,
    public translateService: TranslateService,
    private modalService: ModalService,
    private injector: Injector
  ) {
  }

  getItemIdToDelete(): string | undefined {
    return this.itemIdTodelete;
  }
  getListaToDeleteFrom(): string {
    return this.listaToDeleteFrom;
  }
  setIdItemToDelete(itemId: string | undefined, lista: string) {
    this.itemIdTodelete = ""
    this.listaToDeleteFrom = ""
    if (!itemId || !lista) {
      return;
    } else {
      this.itemIdTodelete = itemId
      this.listaToDeleteFrom = lista
    }
  }
  getPersonalAreaDebtPositions(fiscalNumber: string, codiceIpa: string, limit: boolean, callback: Function | undefined = undefined) {
    this.spinner.show();
    this.errorGettingDebtPositionService = false;
    this.getPosizioneByCodiceFiscaleAndCodiceIpa(fiscalNumber, codiceIpa, limit)
      .subscribe({
        next: (result) => {
          this.storeService.debtPositionsData = result
          this.storeService.debtPositions = result.posizioniDebitorie;
          this.storeService.debtPositionsPagamentiRecenti = result.pagamenti
          this.storeService.setDataAggiornamento(result.dataAggiornamento)
          this.parseDebtPositionsScadute()
          this.parseDebtPositionsInScadenza()
          this.parseDebtPositionsPagate()
          this.parseDebtPositionsPagamentiRecenti_debtPositionsPagate();
          this.logCartItems();

          if (callback != null) {
            callback()
          }
        },
        error: () => {
          this.errorGettingDebtPositionService = true;
          this.spinner.hide()
          if (callback != null) {
            callback()
          }
        },
        complete: () => {
          this.spinner.hide()
          if (callback != null) {
            callback()
          }
        }
      });
  }

  parseDebtPositionsScadute(): void {
    // Ottieni la data corrente
    const currentDate = new Date();

    // Crea una lista per gli elementi scaduti
    const debtPositionsScadute: Array<any> = [];

    // Itera attraverso gli elementi della lista this.storeService.debtPositions
    this.storeService.debtPositions.forEach(debtPosition => {
      if (!!debtPosition.numeroAvviso) {
        if (!debtPosition.isPagato) {
          if (!!debtPosition.dataDiScadenza && !isNaN(Date.parse(debtPosition.dataDiScadenza))) {
            // Ottieni la data di scadenza dell'elemento corrente
            const dataDiScadenza = new Date(debtPosition.dataDiScadenza);

            // Confronta la data di scadenza con la data corrente
            if (dataDiScadenza < currentDate) {
              // Se la data di scadenza è precedente alla data corrente, aggiungi l'elemento alla lista debtPositionsScadute
              debtPositionsScadute.push(debtPosition);
            }
          }
        }
      }
    });

    // Assegna la lista di elementi scaduti alla proprietà this.storeService.debtPositionsScadute
    this.storeService.debtPositionsScadute = debtPositionsScadute;
  }
  parseDebtPositionsInScadenza(): void {
    const currentDate = new Date();
    this.storeService.debtPositionsInScadenza =
      this.storeService.debtPositions.filter(debtPosition => {
        const isInScadenza = debtPosition.dataDiScadenza == null || new Date(debtPosition.dataDiScadenza) >= currentDate
        return (!!debtPosition.numeroAvviso || !!debtPosition.iuv) && !debtPosition.isPagato && isInScadenza;
      });
  }
  parseDebtPositionsPagate(): void {
    // Crea una lista per gli elementi pagati
    const debtPositionsPagate: Array<any> = [];
    // Itera attraverso gli elementi della lista this.storeService.debtPositions
    this.storeService.debtPositions.forEach(debtPosition => {
      if (!!debtPosition.numeroAvviso) {
        if (debtPosition.isPagato && debtPosition.hasReceipt) {
          debtPositionsPagate.push(debtPosition);
        }
      }
    });
    // Assegna la lista di elementi scaduti alla proprietà this.storeService.debtPositionsScadute
    this.storeService.debtPositionsPagate = debtPositionsPagate;
  }
  parseDebtPositionsPagamentiRecenti_debtPositionsPagate(): void {
    const debtPositionsPagamentiRecenti_debtPositionsPagate: PosizioneDebitoria_PagamentiRecenti_Pagata[] = [];
    // Inserisco posizioni DA PAGARE: model "Pagamento"
    this.storeService.debtPositionsPagamentiRecenti.forEach(debtPositionsPagamentiRecenti => {
      debtPositionsPagamentiRecenti.carrelloPagato?.posizioniDebitoriePagata.forEach(debtPosition => {
        const obj: PosizioneDebitoria_PagamentiRecenti_Pagata = {
          importo: debtPosition.importo,
          dataPagamento: debtPositionsPagamentiRecenti.dataPagamento?.toString(),
          numeroAvviso: debtPosition.numeroAvviso,
          causale: debtPosition.causale,
          codiceServizio: debtPosition.codiceServizio,
          descrizioneServizio: debtPosition.descrizioneServizio ? debtPosition.descrizioneServizio : debtPosition.codiceServizio,
          intestazioneEnte: debtPosition.intestazioneEnte,
          codiceFiscalePartitaIvaCittadino: debtPosition.codiceFiscalePartitaIvaCittadino,
          codiceEnteCreditore: debtPosition.codiceEnteCreditore,
          tipo: debtPosition.isPagato == true && debtPosition.hasReceipt == true ? 'pagata' : 'dapagare'
        }
        debtPositionsPagamentiRecenti_debtPositionsPagate.push(obj);
      });
    });

    // Inserisco posizioni PAGATE: model "PosizioneDebitoria"
    this.storeService.debtPositions.forEach(debtPosition => {
      if (!!debtPosition.numeroAvviso) {
        if (debtPosition.isPagato && debtPosition.hasReceipt) {
          const obj: PosizioneDebitoria_PagamentiRecenti_Pagata = {
            importo: debtPosition.importo,
            dataPagamento: debtPosition.dataPagamento,
            numeroAvviso: debtPosition.numeroAvviso,
            causale: debtPosition.causale,
            codiceServizio: debtPosition.codiceServizio,
            descrizioneServizio: debtPosition.descrizioneServizio ? debtPosition.descrizioneServizio : debtPosition.codiceServizio,
            intestazioneEnte: debtPosition.intestazioneEntePlugAndPay ?? '',
            codiceFiscalePartitaIvaCittadino: debtPosition.datiContribuente?.codiceFiscalePartitaIva,
            codiceEnteCreditore: debtPosition.codiceEntePlugAndPay,
            tipo: 'pagata'
          }
          debtPositionsPagamentiRecenti_debtPositionsPagate.push(obj);
        }
      }
    });
    this.storeService.debtPositionsPagamentiRecenti_debtPositionsPagate = debtPositionsPagamentiRecenti_debtPositionsPagate;
  }
  logCartItems() {
    // console.groupCollapsed('Carrelli');
    const carts$ = this.cartService.carrelli$;
    carts$.subscribe(carts => {
      carts.forEach(cart => {
        // console.log(`Carrello di tipo ${cart.tipologiaCarrello}`, cart.posizioniDebitorie);
      });
      // console.groupEnd();
    });
  }

  getPosizioneByCodiceFiscaleAndCodiceIpa(codiceFiscale: string, codiceIpa: string, limit: boolean): Observable<AreaPersonale> {
    return this.http.get<AreaPersonale>(`${this.path.posizioniUrlAreaPersonale}/${codiceFiscale}/${codiceIpa}/${limit}`)
  }
  putPositionsPersonalArea(codiceFiscale: string, codiceIpa: string) {
    this.personalAreaDebtPositionsLimit = false;

    this.spinner.show()
    this._putPositionsPersonalArea(codiceFiscale, codiceIpa)
      .subscribe({
        next: () => {
          const aggiornaProfiloTitolo = this.translateService.instant('aggiorna-profilo-titolo');
          const aggiornaProfiloMessaggio = this.translateService.instant('aggiorna-profilo-messaggio');
          this.toastr.info(aggiornaProfiloMessaggio, aggiornaProfiloTitolo);

          this.getPersonalAreaDebtPositions(
            codiceFiscale,
            codiceIpa,
            true // Sul bottone AGGIORNA, eseguo la chiamata con il limit impostato a 6 mesi (true)
          )
        },
        error: () => { // Callback di errore
          this.spinner.hide()
        },
        complete: () => { // Callback di completamento
          this.spinner.hide()
        }
      });
  }
  _putPositionsPersonalArea(codiceFiscale: string, codiceIpa: string) {
    let url = `${this.path.posizioniUrlAreaPersonale}/${codiceFiscale}/${codiceIpa}`
    return this.http.put<boolean>(url, null) // che sia passato null è intensione
  }
  updateProfileMail(codiceFiscale: string, codiceIpaEnte: string, emailUtente: string): Observable<any> {
    // Check if any required parameter is missing or empty
    if (!codiceFiscale || !codiceIpaEnte || !emailUtente) {
        console.warn('Skipping updateProfileMail: Missing required parameters.');
        return of(null); // Return an empty observable so the pipe doesn't break
    }
    const url = `${this.path.posizioniServiceUrl}/profilemailupdate/${codiceFiscale}/${codiceIpaEnte}`;
    const body = {
      emailUtente: emailUtente
    };
    return this.http.put<any>(url, body);
  }
  private _deleteDebtPosition(codiceFiscale: string, codiceIpa: string, id: string): Observable<void> {
    return this.http.delete<void>(`${this.path.posizioniServiceUrl}/${id}/${codiceFiscale}/${codiceIpa}`)
  }
  postStampaAvvisoDashboard(posizioneSimpleDetail: {
    codiceEnteCreditore: string,
    identificativoPosizione: string,
    codiceIpaEnte: string,
    idApplicazioneEntePosizione: string | undefined,
  }): Observable<any> {
    return this.http.post<any>(`${this.path.areaPagamentoStampaAvvisoUrl}`, posizioneSimpleDetail);
  }

  /**
   * Da usare per stampare uno spontaneo ma autenticato
   * questa chiamata genera una entry su plug&pay;
   * @param posizioneDebitoria
   * @param codiceIpaEnte
   */
  postStampaAvvisoSpontaneo(posizioneDebitoria: {
    posizioneDebitoriaViewModel: PosizioneDebitoria
  }, codiceIpaEnte: string): Observable<{ avvisoPdf: string, numeroAvviso: string }> {
    return this.http.post<any>(`${this.path.posizioniStampaSpontaneoUrl}/${codiceIpaEnte}/spontaneo/stampa`, posizioneDebitoria);
  }

  /**
   * Da usare per stampare uno spontaneo ma non autenticato
   * questa chiamata genera una entry su plug&pay;
   * @param posizioneDebitoria
   * @param codiceIpaEnte
   */
  postStampaAvvisoSpontaneoAnonimo(posizioneDebitoria: {
    posizioneDebitoriaViewModel: PosizioneDebitoria
  }, codiceIpaEnte: string) {
    return this.http.post<{ avvisoPdf: string, numeroAvviso: string }>(`${this.path.posizioniStampaSpontaneoUrl}/${codiceIpaEnte}/spontaneo/anonimo/stampa`, posizioneDebitoria);
  }

  /**
   * api: areapagamentoservice/ente/{codiceIpaEnte}/stamparicevuta
   * @param posizioneDebitoria
   * @param codiceIpaEnte
   * @returns RicevutaPagamentoPdf
   */
  postScaricaRicevutaPagamento(posizioneDebitoria: PosizioneDebitoriaStampaAvviso, codiceIpaEnte: string): Observable<{ avvisoPdf: string, numeroAvviso: string }> {
    return this.http.post<any>(`${this.path.posizioniStampaRicevutaUrl}/${codiceIpaEnte}/stamparicevuta`, posizioneDebitoria);
  }

  /**
   * api: areapagamentoservice/ente/pagaOraGenericoAnonimo
   */
  postPagaOraGenericoAnonimo(posizioneGenericaAnonima: any): Observable<any> {
    return this.http.post<any>(`${this.path.areaPagamentoGenericoAnonimoUrl}`, posizioneGenericaAnonima);
  }

  async downloadPDF(base64String: string, numeroAvviso: string | undefined | null, saveAsName = false) {
    const fileName = (numeroAvviso ?? "avviso") + ".pdf";
    const linkSource = `data:application/pdf;base64,${base64String}`;

    if (window.showSaveFilePicker && window.showSaveFilePicker != null && saveAsName) {
      try {
        // Check for user activation
        if (!navigator.userActivation || !navigator.userActivation.hasBeenActive) {
          throw new Error("No user activation - fallback to download");
        }

        const handle = await window.showSaveFilePicker({
          suggestedName: fileName,
          types: [
            {
              description: fileName,
              accept: {
                'application/pdf': ['.pdf'],
              },
            },
          ],
        });
        const file = await fetch(linkSource)
        const blob = await file.blob()
        await this.writeFile(handle, blob)
        return;
      } catch (e) {
        console.warn("showSaveFilePicker failed, using fallback:", e);
        this.downloadPDFInternal(linkSource, fileName);
      }
    } else {
      this.downloadPDFInternal(linkSource, fileName);
    }

    // if (window.showSaveFilePicker == null) {
    //   this.downloadPDFInternal(linkSource, fileName);
    //   return
    // }
    // if (!saveAsName) {
    //   this.downloadPDFInternal(linkSource, fileName);
    //   return
    // }
    // // https://caniuse.com/?search=showSaveFilePicker doesn't work in safari and firefox
    // if (window.showSaveFilePicker) {
    //   try {
    //     const handle = await window.showSaveFilePicker({
    //       suggestedName: fileName,
    //       types: [
    //         {
    //           description: fileName,
    //           accept: {
    //             'application/pdf': ['.pdf'],
    //           },
    //         },
    //       ],
    //     });
    //     const file = await fetch(linkSource)
    //     const blob = await file.blob()
    //     await this.writeFile(handle, blob)
    //   } catch (e) {
    //     console.error(e)
    //     this.downloadPDFInternal(linkSource, fileName);
    //   }
    // }
  }

  private downloadPDFInternal(linkSource: string, fileName: string) {
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  private async writeFile(fileHandle: FileSystemFileHandle, contents: Blob) {
    // Create a FileSystemWritableFileStream to write to.
    const writable = await fileHandle.createWritable();
    // Write the contents of the file to the stream.
    await writable.write(contents);
    // Close the file and write the contents to disk.
    await writable.close();
  }

  deleteDebtPosition() {
    this.spinner.show()
    const itemFiscalCode = this.authService.getDecodedJWT()?.fiscalNumber;
    if (!!itemFiscalCode) {
      const itemCodIpa = this.storeService.codIpa || "";
      const itemId = this.getItemIdToDelete() ?? ""
      const lista = this.getListaToDeleteFrom()
      this._deleteDebtPosition(itemFiscalCode, itemCodIpa, itemId)
        .subscribe({
          next: () => {
            if (lista === "debtPositionsInScadenza") {
              const index = this.storeService.debtPositionsInScadenza.findIndex(debtPosition => debtPosition.id === itemId);
              if (index > -1) {
                this.storeService.debtPositionsInScadenza.splice(index, 1);
              }
            }
            if (lista === "debtPositionsScadute") {
              const index = this.storeService.debtPositionsScadute.findIndex(debtPosition => debtPosition.id === itemId);
              if (index > -1) {
                this.storeService.debtPositionsScadute.splice(index, 1);
              }
            }
            this.spinner.hide()
          },
          error: () => {
            this.spinner.hide()
          }
        });
    }
  }

  /******************************** PAGAMENTO VELOCE e AREA ESTESA ********************************/
  activeFunctionalityAndUpdatePositionAndProfile(functionality: string, actived: boolean) {
    const authorityId = this.storeService.codIpa;
    const personalData = this.authService.getDecodedJWT();
    const userFiscalCode = this.userService.userProfile?.codiceFiscale ? this.userService.userProfile?.codiceFiscale : personalData?.fiscalNumber;
    const codiceFiscale = userFiscalCode ?? '';
    const codiceIpa = authorityId;

    if (!!personalData) {
      this.spinner.show()
      // First update the user profile, then update positions
      // The positions service needs the user profile to be already updated with the area estesa flag
      this.activeFunctionalityUpdateUserProfileFirst(functionality, actived, codiceFiscale, codiceIpa);
    }
  }
  
  activeFunctionalityUpdateUserProfileFirst(functionality: string, actived: boolean, codiceFiscale: string, codiceIpa: string): void {
    const userProfile: UserProfile | null = this.userService.userProfile;

    if (!!userProfile) {
      if (functionality == 'pagamentoVeloce') {
        userProfile.isPagamentoVeloceAbilitato = actived;
      }
      if (functionality == 'areaEstesa') {
        userProfile.consensoAreaEstesa = actived;
      }
      this.userService.putUserProfile(userProfile)
        .subscribe({
          next: updatedProfile => {
            console.log('activeFunctionalityUpdateUserProfileFirst', updatedProfile);
            this.userService.userProfile = userProfile;
            // After user profile is updated, now update positions
            this.personalAreaDebtPositionsLimit = false;
            this._putPositionsPersonalArea(codiceFiscale, codiceIpa)
              .subscribe({
                next: () => {
                  this.spinner.hide();
                  this.activeFunctionalityUpdatePersonalAreaDebtPositions(codiceFiscale, codiceIpa, true, functionality, actived);
                },
                error: () => {
                  this.spinner.hide();
                }
              });
          },
          error: (error) => {
            console.error('activeFunctionalityUpdateUserProfileFirst', error);
            this.spinner.hide();
          }
        });
    }
  }
  activeFunctionalityUpdatePersonalAreaDebtPositions(fiscalNumber: string, codiceIpa: string, limit: boolean, functionality: string, actived: boolean) {
    this.spinner.show();
    this.errorGettingDebtPositionService = false;
    this.getPosizioneByCodiceFiscaleAndCodiceIpa(fiscalNumber, codiceIpa, limit)
      .subscribe({
        next: (result) => {
          this.storeService.debtPositionsData = result
          this.storeService.debtPositions = result.posizioniDebitorie;
          this.storeService.debtPositionsPagamentiRecenti = result.pagamenti
          this.storeService.setDataAggiornamento(result.dataAggiornamento)
          this.parseDebtPositionsScadute()
          this.parseDebtPositionsInScadenza()
          this.parseDebtPositionsPagate()
          this.parseDebtPositionsPagamentiRecenti_debtPositionsPagate();
          this.logCartItems();

          const aggiornaProfiloTitolo = this.translateService.instant('aggiorna-profilo-titolo');
          const aggiornaProfiloMessaggio = this.translateService.instant('aggiorna-profilo-messaggio');
          this.toastr.info(aggiornaProfiloMessaggio, aggiornaProfiloTitolo);

          this.spinner.hide();
          // User profile is already updated, just show messages and close modal
          this.activeFunctionalityShowMessagesAndCloseModal(functionality, actived);
        },
        error: () => {
          this.errorGettingDebtPositionService = true;
          this.spinner.hide();
        }
      });
  }
  activeFunctionalityShowMessagesAndCloseModal(functionality: string, actived: boolean): void {
    this.modalService.hideModal("user-features");

    if (functionality == 'pagamentoVeloce') {
      const confermaTitolo = this.translateService.instant('paf-pagamento-veloce-title');
      const confermaSottotitolooAttivata = this.translateService.instant('paf-pagamento-veloce-conferma-messaggio-attivazione');
      const confermaSottotitolooDisattivata = this.translateService.instant('paf-pagamento-veloce-conferma-messaggio-disattivazione');
      if(actived) {
        this.toastr.info(confermaSottotitolooAttivata, confermaTitolo);
      } else {
        this.toastr.info(confermaSottotitolooDisattivata, confermaTitolo);
      }
      // Necessario pulire i carrelli utente
      this.cartService.svuotaTuttiICarrelli(this.storeService.authority?.codiceIpaEnte ?? '');
    }
    if (functionality == 'areaEstesa') {
      const estensioneConfermaTitolo = this.translateService.instant('estensione-conferma-titolo');
      const estensioneConfermaSottotitoloAttivata = this.translateService.instant('estensione-conferma-sottotitolo-attivata');
      const estensioneConfermaSottotitoloDisattivata = this.translateService.instant('estensione-conferma-sottotitolo-disattivata');
      if (actived == true) {
        this.toastr.info(estensioneConfermaSottotitoloAttivata, estensioneConfermaTitolo);
      } else {
        this.toastr.info(estensioneConfermaSottotitoloDisattivata, estensioneConfermaTitolo);
      }
    }
  }
  
  activeFunctionalityUpdateUserProfile(functionality: string, actived: boolean): void {
    const userProfile: UserProfile | null = this.userService.userProfile;

    if (!!userProfile) {
      if (functionality == 'pagamentoVeloce') {
        userProfile.isPagamentoVeloceAbilitato = actived;
      }
      if (functionality == 'areaEstesa') {
        userProfile.consensoAreaEstesa = actived;
      }
      this.spinner.show()
      this.userService.putUserProfile(userProfile)
        .subscribe({
          next: updatedProfile => {
            console.log('activeFunctionalityUpdateUserProfile', updatedProfile);

            this.spinner.hide();
            this.modalService.hideModal("user-features");

            if (functionality == 'pagamentoVeloce') {
              const confermaTitolo = this.translateService.instant('paf-pagamento-veloce-title');
              const confermaSottotitolooAttivata = this.translateService.instant('paf-pagamento-veloce-conferma-messaggio-attivazione');
              const confermaSottotitolooDisattivata = this.translateService.instant('paf-pagamento-veloce-conferma-messaggio-disattivazione');
              if(actived) {
                this.toastr.info(confermaSottotitolooAttivata, confermaTitolo);
              } else {
                this.toastr.info(confermaSottotitolooDisattivata, confermaTitolo);
              }
              // Necessario pulire i carrelli utente
              this.cartService.svuotaTuttiICarrelli(this.storeService.authority?.codiceIpaEnte ?? '');
            }
            if (functionality == 'areaEstesa') {
              const estensioneConfermaTitolo = this.translateService.instant('estensione-conferma-titolo');
              const estensioneConfermaSottotitoloAttivata = this.translateService.instant('estensione-conferma-sottotitolo-attivata');
              const estensioneConfermaSottotitoloDisattivata = this.translateService.instant('estensione-conferma-sottotitolo-disattivata');
              if (actived == true) {
                this.toastr.info(estensioneConfermaSottotitoloAttivata, estensioneConfermaTitolo);
              } else {
                this.toastr.info(estensioneConfermaSottotitoloDisattivata, estensioneConfermaTitolo);
              }
            }
            this.userService.userProfile = userProfile;
          },
          error: (error) => {
            console.error('activeFunctionalityUpdateUserProfile', error);
            this.spinner.hide();
          }
        });
    }
  }
  // TODO - Non usata: verificare se serve e se i metodi precedenti funzionano
  activeBothFunctionalities(): void {
    // PAGAMENTO VELOCE
    const userProfile: UserProfile | null = this.userService.userProfile;
    if (!userProfile) {
      return;
    }
    userProfile.isPagamentoVeloceAbilitato = true;
    this.spinner.show()
    this.userService.putUserProfile(userProfile)
      .subscribe({
        next: updatedProfile => {
          // Necessario pulire i carrelli utente
          this.cartService.svuotaTuttiICarrelli(this.storeService.authority?.codiceIpaEnte ?? '');
          // Add message
          const confermaTitolo = this.translateService.instant('paf-pagamento-veloce-title');
          const confermaSottotitolooAttivata = this.translateService.instant('paf-pagamento-veloce-conferma-messaggio-attivazione');
          this.toastr.info(confermaSottotitolooAttivata, confermaTitolo);

          // AREA ESTESA
          const authorityId = this.storeService.codIpa;
          const personalData = this.authService.getDecodedJWT();
          const userFiscalCode = this.userService.userProfile?.codiceFiscale ? this.userService.userProfile?.codiceFiscale : personalData?.fiscalNumber;
          const codiceFiscale = userFiscalCode ?? '';
          const codiceIpa = authorityId;

          if (!!personalData) {
            this.personalAreaDebtPositionsLimit = false;
            this._putPositionsPersonalArea(codiceFiscale, codiceIpa)
              .subscribe({
                next: () => {
                  this.errorGettingDebtPositionService = false;
                  this.getPosizioneByCodiceFiscaleAndCodiceIpa(codiceFiscale, codiceIpa, true)
                    .subscribe({
                      next: (result) => {
                        this.storeService.debtPositionsData = result
                        this.storeService.debtPositions = result.posizioniDebitorie;
                        this.storeService.debtPositionsPagamentiRecenti = result.pagamenti
                        this.storeService.setDataAggiornamento(result.dataAggiornamento)
                        this.parseDebtPositionsScadute()
                        this.parseDebtPositionsInScadenza()
                        this.parseDebtPositionsPagate()
                        this.parseDebtPositionsPagamentiRecenti_debtPositionsPagate();
                        this.logCartItems();

                        const aggiornaProfiloTitolo = this.translateService.instant('aggiorna-profilo-titolo');
                        const aggiornaProfiloMessaggio = this.translateService.instant('aggiorna-profilo-messaggio');
                        this.toastr.info(aggiornaProfiloMessaggio, aggiornaProfiloTitolo);

                        const userProfile: UserProfile | null = this.userService.userProfile;
                        if (!!userProfile) {
                          userProfile.consensoAreaEstesa = true;
                          this.userService.putUserProfile(userProfile)
                            .subscribe({
                              next: updatedProfile => {
                                console.log('activeFunctionalityUpdateUserProfile', updatedProfile);
                                const estensioneConfermaTitolo = this.translateService.instant('estensione-conferma-titolo');
                                const estensioneConfermaSottotitoloAttivata = this.translateService.instant('estensione-conferma-sottotitolo-attivata');
                                this.toastr.info(estensioneConfermaSottotitoloAttivata, estensioneConfermaTitolo);

                                this.spinner.hide();
                                this.modalService.hideModal("user-features");
                                this.userService.userProfile = userProfile;
                              },
                              error: (error) => {
                                console.error('activeFunctionalityUpdateUserProfile', error);
                                this.spinner.hide();
                              }
                            });
                        }
                      },
                      error: () => {
                        this.errorGettingDebtPositionService = true;
                        this.spinner.hide();
                      }
                    });
                },
                error: () => {
                  this.spinner.hide();
                }
              });
          }
        },
        error: (error) => {
          console.error('activeBothFunctionalities', error);
          this.spinner.hide();
        }
      });
  }

  private get cartService(): CartService {
    return this.injector.get(CartService);
  }
  
  private get authService(): AuthService {
    return this.injector.get(AuthService);
  }
}
